import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { composeReducer, isArray, isAsync, isDevelopment, isTagged, mergeCurToPre, tagPromise } from '../tools';
import { defaultGlueConfig, GlueConflictPolicy, gluerUniqueFlagKey, gluerUniqueFlagValue, promiseDeprecated, underModelCallbackContext } from './constants';
import genRaceQueue, { errorFlags, promiseDeprecatedError } from './genRaceQueue';
import runtimeVar from './runtimeVar';
import subscribe from './subscribe';
import { callbackToModelsMap, modelToCallbacksMap, modelToRacePromisesMap } from './unsubscribe';
export var defaultReducer = function defaultReducer(_state, data) {
  return data;
};
export var defaultReducerLast = function defaultReducerLast(state, _data) {
  return state;
};
var warning = '你只传入了一个函数参数给gluer，这会被认为是reducer函数而不是初始值。如果你想存储一个函数类型的初始值，请传入两个参数：reducer和初始值。' + 'reducer可以是最简单：(data, state) => data。这个的意思是：传入的数据会直接用来更新state。';
var getWarning = function getWarning(rd) {
  return "".concat(warning).concat(rd.toString());
};
var errorFlagsLength = errorFlags.length;
var raceHandle = function raceHandle(promise, callback, deprecatedFlag) {
  var errorFlag = deprecatedFlag || promiseDeprecated;
  for (var i = 0; i < errorFlagsLength; i += 1) {
    if (errorFlags[i] in promise) {
      callback();
      throw promiseDeprecatedError;
    }
  }
  promise[errorFlag] = true;
};
var makeRacePromiseDeprecated = function makeRacePromiseDeprecated(promise, beginId) {
  for (var i = 0; i < errorFlagsLength; i += 1) {
    if (errorFlags[i] in promise) {
      return;
    }
  }
  if (typeof beginId === 'number') {
    if (beginId === promise.originId) {
      promise[promiseDeprecated] = true;
    }
    return;
  }
  if (typeof promise.originId !== 'number') {
    promise[promiseDeprecated] = true;
  }
};
var deleteRacePromise = function deleteRacePromise(promise) {
  modelToRacePromisesMap.forEach(function (value) {
    if (value.has(promise)) {
      value.delete(promise);
    }
  });
};
var isUnderModelCallbackContext = function isUnderModelCallbackContext() {
  return runtimeVar.runtimeRacePromiseContext === underModelCallbackContext;
};
var isBoundByUseModel = function isBoundByUseModel(bindType) {
  return bindType === 1;
};
var isOnUpdateListenTypeCallback = function isOnUpdateListenTypeCallback(callback) {
  return callback.__listen_type === 1;
};
function glue() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var rd = args[0],
    initialState = args[1];
  var reducerFnc;
  var initState = initialState;
  if (args.length === 0) {
    reducerFnc = defaultReducerLast;
  } else if (args.length === 1) {
    if (typeof rd !== 'function') {
      reducerFnc = defaultReducerLast;
      initState = rd;
    } else {
      reducerFnc = rd;
      if (isDevelopment()) {
        console.warn(getWarning(rd));
      }
    }
  } else if (typeof rd !== 'function') {
    reducerFnc = defaultReducerLast;
  } else {
    reducerFnc = rd;
  }
  var glueState = initState;
  var glueConfig = defaultGlueConfig;
  var fn;
  var rq = genRaceQueue();
  var updateFn = function updateFn(data, silent, mutedCallback) {
    if (!silent) {
      runtimeVar.runtimeRacePromiseContext = underModelCallbackContext;
      var updateType;
      var callbackIds;
      if (runtimeVar.runtimeUpdateOrigin) {
        updateType = runtimeVar.runtimeUpdateOrigin.updateType;
        callbackIds = runtimeVar.runtimeUpdateOrigin.callbackIds;
        runtimeVar.runtimeUpdateOrigin = {
          updateType: updateType,
          callbackIds: []
        };
      }
      var isInvalidCallback = function isInvalidCallback(caba) {
        var _callbackIds;
        var isBoundByUM = isBoundByUseModel(caba.__bind_type);
        return isBoundByUM && (!((_callbackIds = callbackIds) !== null && _callbackIds !== void 0 && _callbackIds.length) || callbackIds.indexOf(caba.__id) === -1);
      };
      var onUpdateListenTypeCallback = [];
      var cbs = modelToCallbacksMap.get(fn);
      if (!Object.is(data, glueState)) {
        glueState = data;
        cbs === null || cbs === void 0 ? void 0 : cbs.forEach(function (callback) {
          if (callback !== mutedCallback) {
            if (callbackToModelsMap.has(callback)) {
              if (isInvalidCallback(callback)) return;
              if (isOnUpdateListenTypeCallback(callback)) {
                onUpdateListenTypeCallback.push(callback);
                return;
              }
              var mods = callbackToModelsMap.get(callback);
              var values = Array.from(mods).reduce(function (pre, cur) {
                return [].concat(_toConsumableArray(pre), [cur()]);
              }, []);
              callback.apply(void 0, _toConsumableArray(values));
            }
          }
        });
      }
      if (onUpdateListenTypeCallback.length) {
        onUpdateListenTypeCallback.forEach(function (callback) {
          callback(glueState);
        });
      } else {
        cbs === null || cbs === void 0 ? void 0 : cbs.forEach(function (callback) {
          if (callback !== mutedCallback) {
            if (isOnUpdateListenTypeCallback(callback)) {
              if (isInvalidCallback(callback)) return;
              callback(glueState);
            }
          }
        });
      }
      runtimeVar.runtimeRacePromiseContext = '';
    } else if (!Object.is(data, glueState)) {
      glueState = data;
    }
  };
  var preTreat = function preTreat() {
    var payload;
    var customHandler;
    for (var _len2 = arguments.length, ags = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      ags[_key2] = arguments[_key2];
    }
    if (ags.length === 0) {
      return glueState;
    }
    if (ags.length === 1) {
      if (typeof ags[0] === 'function') {
        customHandler = ags[0];
      } else {
        payload = ags[0];
      }
    } else {
      payload = ags[0];
      customHandler = ags[1];
    }
    var tmpHandler = customHandler || defaultReducer;
    var realHandler = composeReducer(tmpHandler, reducerFnc);
    return realHandler(glueState, payload);
  };
  var basicLogic = function basicLogic() {
    var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return function () {
      var _glueConfig3;
      for (var _len3 = arguments.length, ags = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        ags[_key3] = arguments[_key3];
      }
      if (ags.length === 0) return glueState;
      var tempResult;
      if (runtimeVar.runtimeNoPreTreat) {
        tempResult = ags[0];
        runtimeVar.runtimeNoPreTreat = false;
      } else {
        tempResult = preTreat.apply(void 0, ags);
      }
      if (!silent) {
        if (runtimeVar.runtimeDepsModelCollectedMap.has(fn)) return tempResult;
        runtimeVar.runtimeDepsModelCollectedMap.set(fn, 0);
      }
      var deleteSelf = function deleteSelf() {
        if (!silent) {
          runtimeVar.runtimeDepsModelCollectedMap.delete(fn);
        }
      };
      var mutedCallback = ags[2];
      if (isAsync(tempResult)) {
        var forAsyncRuntimeDepsModelCollectedMap;
        var forAsyncRuntimeUpdateOrigin;
        var forAsyncRuntimeRacePromisesCollectedSet;
        var forAsyncRuntimeBeginOriginId;
        if (!silent) {
          var _runtimeVar$runtimeRa;
          forAsyncRuntimeDepsModelCollectedMap = new Map(runtimeVar.runtimeDepsModelCollectedMap);
          forAsyncRuntimeUpdateOrigin = runtimeVar.runtimeUpdateOrigin ? _objectSpread({}, runtimeVar.runtimeUpdateOrigin) : null;
          forAsyncRuntimeRacePromisesCollectedSet = (_runtimeVar$runtimeRa = runtimeVar.runtimeRacePromisesCollectedSet) !== null && _runtimeVar$runtimeRa !== void 0 ? _runtimeVar$runtimeRa : null;
          forAsyncRuntimeBeginOriginId = runtimeVar.runtimeBeginOriginId;
        }
        if (isDevelopment() && isTagged(tempResult)) {
          console.warn('传入的promise已经被model使用了，请勿重复传入相同的promise，这样可能导致异步竞争，从而取消promise！');
        }
        var depsClearCallback = function depsClearCallback() {
          forAsyncRuntimeDepsModelCollectedMap = null;
        };
        var errorFlag = runtimeVar.runtimePromiseDeprecatedFlag;
        var promise = tempResult.catch(function (e) {
          var _glueConfig;
          deleteRacePromise(promise);
          if (((_glueConfig = glueConfig) === null || _glueConfig === void 0 ? void 0 : _glueConfig.updatePolicy) === GlueConflictPolicy.merge) {
            rq.replace(promise, null);
            return Promise.reject(e);
          }
          rq.replace(promise);
          raceHandle(promise, depsClearCallback, errorFlag);
          return Promise.reject(e);
        }).then(function () {
          var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(data) {
            var _glueConfig2;
            var tmpData, pIndex, arrBefore, dataArr, values;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    tmpData = data;
                    deleteRacePromise(promise);
                    if (!(((_glueConfig2 = glueConfig) === null || _glueConfig2 === void 0 ? void 0 : _glueConfig2.updatePolicy) === GlueConflictPolicy.merge)) {
                      _context.next = 18;
                      break;
                    }
                    pIndex = rq.getIndex(promise);
                    arrBefore = rq.slice(0, pIndex < 0 ? 0 : pIndex);
                    rq.replace(promise, tmpData);
                    if (!(arrBefore !== null && arrBefore !== void 0 && arrBefore.length)) {
                      _context.next = 15;
                      break;
                    }
                    _context.next = 9;
                    return Promise.allSettled(arrBefore);
                  case 9:
                    dataArr = _context.sent;
                    values = [];
                    dataArr === null || dataArr === void 0 ? void 0 : dataArr.forEach(function (d) {
                      if (d.status === 'fulfilled') {
                        values.push(d === null || d === void 0 ? void 0 : d.value);
                      }
                    });
                    tmpData = mergeCurToPre([glueState].concat(values, [tmpData]));
                    _context.next = 16;
                    break;
                  case 15:
                    tmpData = mergeCurToPre([glueState, tmpData]);
                  case 16:
                    _context.next = 20;
                    break;
                  case 18:
                    rq.replace(promise);
                    raceHandle(promise, depsClearCallback, errorFlag);
                  case 20:
                    if (!silent) {
                      runtimeVar.runtimeDepsModelCollectedMap = forAsyncRuntimeDepsModelCollectedMap;
                      runtimeVar.runtimeUpdateOrigin = forAsyncRuntimeUpdateOrigin;
                      runtimeVar.runtimeRacePromisesCollectedSet = forAsyncRuntimeRacePromisesCollectedSet;
                      runtimeVar.runtimeBeginOriginId = forAsyncRuntimeBeginOriginId;
                    }
                    updateFn(tmpData, silent, mutedCallback);
                    if (!silent) {
                      runtimeVar.runtimeDepsModelCollectedMap.clear();
                      runtimeVar.runtimeUpdateOrigin = null;
                      runtimeVar.runtimeRacePromisesCollectedSet = null;
                      runtimeVar.runtimeBeginOriginId = null;
                    }
                    return _context.abrupt("return", tmpData);
                  case 24:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
        if (isDevelopment()) {
          tagPromise(promise);
        }
        deleteSelf();
        return promise;
      }
      var finalTempResult = tempResult;
      if (((_glueConfig3 = glueConfig) === null || _glueConfig3 === void 0 ? void 0 : _glueConfig3.updatePolicy) === GlueConflictPolicy.merge) {
        finalTempResult = mergeCurToPre([glueState, tempResult]);
      }
      updateFn(finalTempResult, silent, mutedCallback);
      deleteSelf();
      return finalTempResult;
    };
  };
  fn = basicLogic(false);
  fn.reset = function () {
    fn(initState);
  };
  fn.watch = function (models, callback) {
    if (!isArray(models) || models.length === 0) {
      throw new Error('dependencies should be Array, ant not empty');
    }
    var subCallback = function subCallback() {
      if (runtimeVar.runtimeDepsModelCollectedMap.has(fn)) return;
      for (var _len4 = arguments.length, data = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        data[_key4] = arguments[_key4];
      }
      fn(callback(data, fn()));
    };
    return subscribe(models, subCallback, false);
  };
  fn.onChange = function (callback) {
    if (typeof callback !== 'function') {
      throw new Error('callback should be function');
    }
    return subscribe([fn], callback, false);
  };
  fn.onUpdate = function (callback) {
    if (typeof callback !== 'function') {
      throw new Error('callback should be function');
    }
    runtimeVar.runtimeListenType = 1;
    var unsub = subscribe([fn], callback, false);
    runtimeVar.runtimeListenType = 0;
    return unsub;
  };
  fn.silent = basicLogic(true);
  fn.race = function () {
    var _fn;
    for (var _len5 = arguments.length, as = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      as[_key5] = arguments[_key5];
    }
    var realValue = (_fn = fn).preTreat.apply(_fn, as);
    var realValueIsAsync = isAsync(realValue);
    var tmp = Promise.resolve(realValue);
    if (!modelToRacePromisesMap.has(fn)) {
      modelToRacePromisesMap.set(fn, new Set());
    }
    var underModelCallbackContextRacePromises = modelToRacePromisesMap.get(fn);
    var iumcc = isUnderModelCallbackContext();
    if (typeof runtimeVar.runtimeBeginOriginId !== 'number') {
      runtimeVar.runtimeBeginOriginId = runtimeVar.runtimeUpdateOriginId;
    }
    if (!iumcc) {
      underModelCallbackContextRacePromises.forEach(function (p) {
        makeRacePromiseDeprecated(p, runtimeVar.runtimeBeginOriginId);
      });
      underModelCallbackContextRacePromises.clear();
      runtimeVar.runtimeRacePromisesCollectedSet = underModelCallbackContextRacePromises;
    }
    var mutedCallback = as[2];
    runtimeVar.runtimeNoPreTreat = true;
    if (realValueIsAsync) {
      tmp = fn(realValue, defaultReducer, mutedCallback);
    } else {
      fn(realValue, defaultReducer, mutedCallback);
    }
    if (iumcc && realValueIsAsync) {
      var _runtimeVar$runtimeRa2;
      if (typeof runtimeVar.runtimeBeginOriginId === 'number') {
        tmp.originId = runtimeVar.runtimeBeginOriginId;
      }
      (_runtimeVar$runtimeRa2 = runtimeVar.runtimeRacePromisesCollectedSet) === null || _runtimeVar$runtimeRa2 === void 0 ? void 0 : _runtimeVar$runtimeRa2.add(tmp);
    }
    runtimeVar.runtimeBeginOriginId = null;
    rq.push(realValueIsAsync ? tmp : realValue, runtimeVar.runtimePromiseDeprecatedFlag);
    return tmp;
  };
  fn.preTreat = function () {
    return preTreat.apply(void 0, arguments);
  };
  fn.config = function () {
    for (var _len6 = arguments.length, as = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      as[_key6] = arguments[_key6];
    }
    if (as.length === 0) return glueConfig;
    glueConfig = as[0];
    return glueConfig;
  };
  Object.defineProperty(fn, gluerUniqueFlagKey, {
    value: gluerUniqueFlagValue,
    writable: false,
    configurable: true,
    enumerable: true
  });
  return fn;
}
export default glue;